import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Users from '../views/Users/Index.vue'
import Clients from '../views/Clients/Index.vue'
import Packages from '../views/Packages/Index.vue'
import taxes from '../views/Taxes/Index.vue'
import Configuration from '../views/Configuration/Index.vue'

import { Role } from '../helpers/Role.js';


Vue.use(VueRouter)

  const routes = [
  {
    path: '',
      component: () => import('../views/Layouts/Main.vue'),
      children: [
        
        {
          path: '/',
          name: 'Home',
          component: Home,
          meta: {
            breadcrumb: [
              { title: 'Inicio', active: true },
            ],
            pageTitle: '',
            authorize: []
          }
        },
        {
          path: '/packages',
          name: 'packages',
          component: Packages,
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Paquetes', active: true }
            ],
            pageTitle: 'Paquetes',
            authorize: [],
          }
        },
        {
          path: '/package/:id',
          name: 'Package',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Paquetes', url: '/packages' },
              { title: 'Paquete', active: true }
            ],
            pageTitle: 'Paquete',
            authorize: [],
            //authorize: []
          },
          component: () => import('../views/Packages/Package.vue')
        },
        {
          path: '/packages/updateStatus',
          name: 'PackageUpdate',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Paquetes', url: '/packages' },
              { title: 'Basado tracking', active: true }
            ],
            pageTitle: 'Actualización Estado',
            authorize: [],
            //authorize: []
          },
          component: () => import('../views/Inventories/UpdatePacksByTracking.vue')
        },
        {
          path: '/packages/report',
          name: 'PackageReport',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Paquetes', url: '/packages', active: true },
            ],
            pageTitle: 'Reporte',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Packages/Report.vue')
        },
        {
          path: '/pre-alert',
          name: 'PreAlert',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Paquetes', url: '/packages' },
              { title: 'Nuevo', active: true }
            ],
            pageTitle: 'Pre Alerta',
            authorize: [],
            //authorize: []
          },
          component: () => import('../views/Packages/PreAlert.vue')
        },
        {
          path: '/clients',
          name: 'clients',
          component: Clients,
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Clientes', active: true }
            ],
            pageTitle: 'Clientes',
            authorize: [ Role.Admin ],
            //authorize: [ Role.Admin ],
          }
        },  
                
        {
          path: '/surveys',
          name: 'SurveyRoute',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Encuestas', active: true }
            ],
            pageTitle: 'Encuestas',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Survey/Index.vue')
        }, 

        {
          path: '/customers/:id',
          name: 'Customer',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Clientes', url: '/clients' },
              { title: 'Cliente', active: true }
            ],
            pageTitle: 'Cliente',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Clients/Client.vue')
        },   
        {
          path: '/customer-types',
          name: 'CustomerTypes',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Clientes', url: '/clients', active: true }
            ],
            pageTitle: 'Tipos de cliente',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Clients/CustomerTypes.vue')
        },
        
        {
          path: '/customer/manage/:id?',
          name: 'CustomerManage',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Clientes', url: '/clients' },
              { title: 'Cliente', active: true }
            ],
            pageTitle: 'Cliente',
            authorize: [ Role.Admin ],
            //authorize: []
          },
          component: () => import('../views/Clients/Manage.vue')
        },
                
        {
          path: '/cashback',
          name: 'Cashback',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CashBox', active: true }
            ],
            pageTitle: 'CashBox',
            // authorize: [ Role.Admin ],
          },
          component: () => import('../views/Clients/Cashback.vue')
        },

        {
          path: '/cashback/rates',
          name: 'CashbackRates',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CashBox', active: true }
            ],
            pageTitle: 'Rates',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Rates.vue')
        },
        
        {
          path: '/memberships',
          name: 'Memberships',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Membresías', active: true }
            ],
            pageTitle: 'Membresías',
            // authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Index.vue')
        },

        {
          path: '/cashback/summary',
          name: 'CashbackSummary',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CashBox', active: true }
            ],
            pageTitle: 'Control de CashBox',
            // authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Cashback.vue')
        },
        {
          path: '/cashback/detail/:id',
          name: 'CashbackDetail',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Control de CashBox', active: true }
            ],
            pageTitle: 'Detalle',
            // authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/CashbackDetail.vue')
        },
        {
          path: '/cashback/member/detail/:id/:customer',
          name: 'CashbackMemberDetail',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Control de CashBox', active: true }
            ],
            pageTitle: 'Paquetes',
            // authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/CashbackMemberDetail.vue')
        },
        {
          path: '/membership/detail/:id',
          name: 'MembershipDetail',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Membresías', active: true }
            ],
            pageTitle: 'Membresías',
            // authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/CustomerDetail.vue')
        },

        {
          path: '/admin/memberships',
          name: 'AdminMemberships',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Membresías', active: true }
            ],
            pageTitle: 'Membresías',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Admin/Index.vue')
        },

        {
          path: '/admin/membership/detail/:id',
          name: 'AdminMembership',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Membresías', active: true }
            ],
            pageTitle: 'Membresía',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Admin/Membership.vue')
        },

        {
          path: '/admin/cashback/detail/:id',
          name: 'AdminCashbackDetail',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CashBox', active: true }
            ],
            pageTitle: 'Detalle',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Admin/Cashback.vue')
        },

        {
          path: '/admin/cashback/member/detail/:id/:customer',
          name: 'CashbackMemberDetailAd',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'CashBox', active: true }
            ],
            pageTitle: 'Detalle',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Admin/CashbackMemberDetail.vue')
        },

        {
          path: '/admin/franchises/member/detail/:id',
          name: 'MemberDetails',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Afiliado', active: true }
            ],
            pageTitle: 'Detalle',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Memberships/Admin/MemberDetail.vue')
        },
        
        {
          path: '/taxes',
          name: 'taxes',
          component: taxes,
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Aranceles', active: true }
            ],
            pageTitle: 'Aranceles',
            authorize: [ Role.Admin ],
          }
        },
        
        {
          path: '/orders',
          name: 'orders',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Ordenes', active: true }
            ],
            pageTitle: 'Despacho',
            authorize: [ Role.Admin, Role.Warehouse],
          },          
          component: () => import('../views/Orders/Index.vue')
        },
        
        {
          path: '/order-detail/:id',
          name: 'OrderDetail',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Ordenes', active: true }
            ],
            pageTitle: 'Despacho',
            authorize: [ Role.Admin, Role.Warehouse],
          },          
          component: () => import('../views/Orders/Detail.vue')
        },

        {
          path: '/create-order',
          name: 'CreateOrder',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Ordenes', active: true }
            ],
            pageTitle: 'Despacho',
            authorize: [ Role.Admin ],
          },          
          component: () => import('../views/Orders/Create.vue')
        },

        {
          path: '/operations',
          name: 'operations',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Operaciones', active: true }
            ],
            pageTitle: 'Operaciones',
            authorize: [ Role.Admin],
          },          
          component: () => import('../views/Operations/Index.vue')
        },

        {
          path: '/inventories',
          name: 'inventories',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Inventario', active: true }
            ],
            pageTitle: 'Inventario',
            authorize: [ Role.Admin, Role.Warehouse],
          },          
          component: () => import('../views/Inventories/Index.vue')
        },

        {
          path: '/inventory/add/:id?',
          name: 'inventoryAdd',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Inventario', active: true }
            ],
            pageTitle: 'Agregar',
            authorize: [ Role.Admin , Role.Warehouse],
          },          
          component: () => import('../views/Inventories/Create.vue')
        },
        {
          path: '/inventory/detail/:id',
          name: 'InventoryDetail',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Inventario', active: true }
            ],
            pageTitle: 'Paquete',
            authorize: [ Role.Admin, Role.Warehouse],
          },          
          component: () => import('../views/Inventories/Detail.vue')
        },

        {
          path: '/inventory/track',
          name: 'inventoryTrack',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Inventario', active: true }
            ],
            pageTitle: 'Buscar',
            authorize: [ Role.Admin ],
          },          
          component: () => import('../views/Inventories/Track.vue')
        },

        {
          path: '/users',
          name: 'users',
          component: Users,
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Usuarios', active: true }
            ],
            pageTitle: 'Usuarios',
            authorize: [ Role.Admin ],
          }
        },
        {
          path: '/configuration',
          name: 'Box Logistics',
          component: Configuration,
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Configuración', active: true }
            ],
            pageTitle: 'Box Logistics',
            authorize: [ Role.Admin ],
          }
        },
        {
          path: '/profile',
          name: 'Profile',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Perfil', active: true }
            ],
            pageTitle: 'Usuario',
            authorize: [],
          },
          component: () => import('../views/Users/Profile.vue')
        },
        {
          path: '/address',
          name: 'Address',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Dirección en Miami', active: true }
            ],
            pageTitle: 'Tu dirección',
            authorize: [],
          },
          component: () => import('../views/Clients/Address.vue')
        },     
        {
          path: '/credit-lines',
          name: 'CreditLines',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Crédito', active: true }
            ],
            pageTitle: 'Lineas de crédito',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Credits/CreditLines.vue')
        },     
        {
          path: '/credits',
          name: 'Credits',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Créditos', active: true }
            ],
            pageTitle: 'Créditos',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Credits/Index.vue')
        },     
        {
          path: '/reporte-ventas',
          name: 'ReporteVentas',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Reporte', active: true }
            ],
            pageTitle: 'Ventas',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Reports/Index.vue')
        },

            
        {
          path: '/routes',
          name: 'RouteDeliveries',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rutas', active: true }
            ],
            pageTitle: 'Listado',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Deliveries/Index.vue')
        },

        {
          path: '/route/:id',
          name: 'RouteDeliveryDetails',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rutas', active: true }
            ],
            pageTitle: 'Ruta',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Deliveries/Detail.vue')
        },

        {
          path: '/routes/create',
          name: 'RouteDeliveryCreate',
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Rutas', active: true }
            ],
            pageTitle: 'Nueva Ruta',
            authorize: [ Role.Admin ],
          },
          component: () => import('../views/Deliveries/Create.vue')
        },
        
        
      ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: {},
    component: () => import('../views/Auth/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if ( savedPosition ) {
      return savedPosition
    } else {
      const position = {} 
      if (to.hash) {
        position.selector = to.hash
        position.behavior = 'smooth'
        if ( document.querySelector(to.hash)) {
          return position
        }
        return false
      }
      return { x: 0, y: 0 }  
    }
  },
  routes
})

export default router

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = JSON.parse(localStorage.getItem('boxcrusr')); //authenticationService.currentUserValue;
  if (authorize) {
      if (!currentUser) {
          console.log('sss') 
        // not logged in so redirect to login page with the return url
          return next({ path: '/login'});
          // query: { returnUrl: to.path } 
      }
      // check if route is restricted by role
      if (authorize.length && !authorize.includes(currentUser.info.role)) {
          // role not authorised so redirect to home page
          return next({ path: '/' });
      }
  }
  next();
})